import store from '@/store/store';
import { PGetAllAnonymeWithLiensInferieursAsync } from '@/api/tiers';
import { TYPE_CLIENT, SOUS_TYPE_AUCUN } from '@/configurations/clientConf';
import { getAllPdvIdsTiers } from '@/services/gestionTiers/getPdv';

export default async function getAllTiersIdsInUser(user) {
  const hash = store.getters['user/hash'];
  const tiersId = user.extend.tiersId || [];
  const groupeIds = user.extend.groupeIds || [];
  const enseigneIds = user.extend.enseigneIds || [];
  const payload = { sousType: [SOUS_TYPE_AUCUN], type: TYPE_CLIENT };
  const payloads = [
    ...groupeIds.map((id) => ({ ...payload, tiersId: id })),
    enseigneIds.length ? { ...payload, enseigneIds } : null,
  ].filter(Boolean);
  if (payloads.length) {
    const response = await Promise.all(payloads.map(async (p) => {
      const res = await PGetAllAnonymeWithLiensInferieursAsync(hash, p);
      return res.data.result.items;
    }));
    tiersId.push(...response.flat().flatMap(getAllPdvIdsTiers));
  }
  return tiersId;
}

function getProfilFromCommercial(commercial) {
  if (!commercial?.profil) return '';
  const { profil } = commercial;
  const profilMap = {
    Commercial: 'Responsable de clientèle',
    DirecteurCommercial: 'Directeur Clientèle',
  };
  return profilMap[profil] || profil.replace(/([a-z])([A-Z])/g, '$1 $2');
}

export function getCommercial(commercials) {
  if (!commercials || !commercials.length) return null;
  const profil = getProfilFromCommercial(commercials[0]);
  const nomComplet = [
    commercials[0].prenom,
    commercials[0].nom ? commercials[0].nom.toUpperCase() : '',
  ].filter(Boolean).join(' ');
  return { ...commercials[0], profil, nomComplet };
}
